import styled from "styled-components";

export const LogoStyled = styled.img`
  width: ${props => props.width || "20.41vw"};
  height: ${props => props.height || "4.72vh"};
`;

export const LGLogoStyled = styled.img`
  width: ${props => props.width || '9.42vw'};
  height: ${props => props.height || '9.53vh'};
`;